import * as React from 'react';
import { Flex } from "../..";
import styled from "../../../styled";
var TagWrapper = styled(Flex)(function (_a) {
    var theme = _a.theme;
    return "\n  :after {\n    content: ' ';\n    position: absolute;\n    bottom: -4px;\n    border-top: 5px solid " + theme.colors.secondary500 + ";\n    border-right: 5px solid transparent;\n    border-left: 5px solid transparent;\n    border-bottom: none;\n  }\n";
});
export var HandleTag = function (_a) {
    var children = _a.children, height = _a.height, percent = _a.percent;
    return (React.createElement(TagWrapper, { lss: {
            alignItems: 'center',
            justifyContent: 'center',
            left: percent + "%",
            position: 'absolute',
            transform: 'translate(-50%, -50%)',
            zIndex: 2,
            borderRadius: 'sm',
            bottom: height * 2 + 18,
            bg: 'secondary500',
            color: 'white',
            px: 'sm',
            py: 'xs'
        } }, children));
};
//# sourceMappingURL=HandleTag.js.map